import * as psl from 'psl';

/**
 * Parses a hostname into its domain and subdomain using the Public Suffix List (PSL).
 * This is a synchronous utility function that returns a plain object.
 *
 * @param {string} [hostname=window.location.hostname] The hostname string to parse. Defaults to the current window's hostname.
 * @returns {{domain: string, subdomain: string | null, isSuperAdmin: boolean}} An object containing the registrable domain, the subdomain and isSuperAdmin.
 * The subdomain will be null if it does not exist or if a parsing error occurs.
 */
export const useHostname = (hostname = window.location.hostname) => {
  // The psl.parse() function is the core of the 'psl' library.
  const parsed = psl.parse(hostname);

  // The 'parsed' object contains an 'error' property if parsing fails.
  if ('error' in parsed) {
    // As a safe fallback, return the original hostname as the domain.
    return { domain: hostname, subdomain: '', isSuperAdmin: false };
  }

  // If successful, return the parsed parts.
  return {
    domain: parsed.domain as string,
    subdomain: parsed.subdomain || '',
    isSuperAdmin: !!parsed.subdomain?.toString().includes('super-admin'),
  };
};
